export default __webpack_public_path__ + "static/media/esupport-light.b455625b.svg";